export default __webpack_public_path__ + "assets/saudi-arabia-flag.png";